import { DomainBase } from "./DomainBase";

export class CurrencyDenomination extends DomainBase{
    constructor() {
        super();
        this.Denomination = 0;
    }
}